// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const menuOpciones = [
    {
        label: 'Super Usuario', icon: 'fa fa-unlock-alt',
        items: [
            { label: 'Empresas', icon: 'pi pi-star', routerLink: ['/empresas'], rol: ['SUPER_USUARIO'] },
            { label: 'Plantillas', icon: 'pi pi-star', routerLink: ['/plantillas'], rol: ['SUPER_USUARIO'] },
            { label: 'Monitoreo', icon: 'pi pi-star', routerLink: ['/monitoreo'], rol: ['SUPER_USUARIO'] },
            { label: 'Control de empresas', icon: 'pi pi-star', routerLink: ['/control-empresas'], rol: ['SUPER_USUARIO'] },
            {
                label: 'Cuotas',
                icon: 'pi pi-star',
                routerLink: ['/cuotas'],
                rol: ['SUPER_USUARIO']
            },
        ],
        rol: ['SUPER_USUARIO']
    },

    {
        label: 'Dashboard',
        icon: 'fa fa-pie-chart',
        routerLink: ['/dashboard'],
        rol: ['SUPER_USUARIO', 'DASHBOARD_VER']
    },
    {
        label: 'Administración', icon: 'fa fa-table',
        items: [
            {
                label: 'Certificados digitales',
                icon: 'fa fa-certificate',
                routerLink: ['/certificados'],
                rol: ['SUPER_USUARIO', 'CERTIFICADOS_VER']
            },
            {
                label: 'Empresas adjuntas',
                icon: 'pi pi-star',
                routerLink: ['/empresas/adjuntas'],
                rol: ['SUPER_USUARIO', 'EMPRESAS_ADJUNTAS_VER']
            },
            {
                label: 'Ciudades',
                icon: 'fa fa-building',
                routerLink: ['/ciudades'],
                rol: ['SUPER_USUARIO', 'CIUDADES_VER']
            },
            {
                label: 'Unidades de medida',
                icon: 'fa fa-balance-scale',
                routerLink: ['/unidades'],
                rol: ['SUPER_USUARIO', 'UNIDADES_VER']
            },
            {
                label: 'Finanzas',
                icon: 'fa fa-money',
                items: [
                    {
                        label: 'Métodos de pago',
                        icon: 'fa fa-credit-card',
                        routerLink: ['/formas-pago'],
                        rol: ['SUPER_USUARIO', 'FORMAS_PAGO_VER']
                    },
                    {
                        label: 'Monedas',
                        icon: 'fa fa-usd',
                        routerLink: ['/monedas'],
                        rol: ['SUPER_USUARIO', 'MONEDAS_VER']
                    },
                    {
                        label: 'Bancos',
                        icon: 'fa fa-university',
                        routerLink: ['/bancos'],
                        rol: ['SUPER_USUARIO', 'BANCOS_VER']
                    },
                    {
                        label: 'Cuentas bancarias',
                        icon: 'fa fa-credit-card-alt',
                        routerLink: ['/cuentas-bancarias'],
                        rol: ['SUPER_USUARIO', 'CUENTAS_BANCARIAS_VER']
                    },
                ],
                rol: ['SUPER_USUARIO', 'CUENTAS_BANCARIAS_VER', 'BANCOS_VER', 'MONEDAS_VER', 'FORMAS_PAGO_VER']
            },
            {
                label: 'Horarios',
                icon: 'fa fa-clock-o',
                routerLink: ['/horarios'],
                rol: ['SUPER_USUARIO', 'HORARIOS_VER']
            },
            {
                label: 'Puntos de venta',
                icon: 'fa fa-street-view',
                routerLink: ['/puntos-venta'],
                rol: ['SUPER_USUARIO', 'PUNTO_VENTA_VER']
            },
            {
                label: 'Estaciones de venta',
                icon: 'fa fa-shopping-bag',
                routerLink: ['/estaciones-venta'],
                rol: ['SUPER_USUARIO', 'SALE_STATION_VER']
            },
            {
                label: 'Series documentos',
                icon: 'fa fa-files-o',
                routerLink: ['/series'],
                rol: ['SUPER_USUARIO', 'SERIES_DOCUMENTOS_VER']
            },
            {
                label: 'Productos', icon: 'fa fa-cubes',
                items: [
                    {
                        label: 'Articulos',
                        icon: 'fa fa-cube',
                        routerLink: ['/productos'],
                        rol: ['SUPER_USUARIO', 'PRODUCTOS_VER']
                    },
                    {
                        label: 'Preparaciones',
                        icon: 'fa fa-list',
                        routerLink: ['/preparaciones'],
                        rol: ['SUPER_USUARIO', 'PREPARACIONES_VER']
                    },
                    {
                        label: 'Grupos',
                        icon: 'fa fa-cubes',
                        routerLink: ['/grupos'],
                        rol: ['SUPER_USUARIO', 'GRUPOS_VER']
                    },
                    {
                        label: 'Categorías',
                        icon: 'fa fa-folder-open',
                        routerLink: ['/categorias/0'],
                        rol: ['SUPER_USUARIO', 'CATEGORIAS_VER']
                    },
                    {
                        label: 'Marcas',
                        icon: 'fa fa-trademark',
                        routerLink: ['/marcas'],
                        rol: ['SUPER_USUARIO', 'MARCAS_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'PRODUCTOS_VER', 'CATEGORIAS_VER', 'MARCAS_VER']
            },
            {
                label: 'Clientes',
                icon: 'fa fa-address-book',
                routerLink: ['/clientes'],
                rol: ['SUPER_USUARIO', 'CLIENTES_VER']
            },
            {
                label: 'Empleados',
                icon: 'fa fa-users',
                items: [
                    {
                        label: 'Ver Empleados',
                        icon: 'fa fa-users',
                        routerLink: ['/empleados'],
                        rol: ['SUPER_USUARIO', 'EMPLEADOS_VER']
                    },
                    {
                        label: 'Asistencia',
                        icon: 'fa fa-calendar-check-o',
                        routerLink: ['/empleados/asistencia'],
                        rol: ['SUPER_USUARIO', 'EMPLEADOS_ASISTENCIA_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'EMPLEADOS_VER', 'EMPLEADOS_ASISTENCIA_VER']
            },
            {
                label: 'Proveedores',
                icon: 'fa fa-truck',
                routerLink: ['/proveedores'],
                rol: ['SUPER_USUARIO', 'PROVEEDORES_VER']
            },
            {
                label: 'Canal de venta',
                icon: 'fa fa-shopping-cart',
                routerLink: ['/canal-ventas'],
                rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
            },
            {
                label: 'Impresoras',
                icon: 'fa fa-print',
                routerLink: ['/impresoras'],
                rol: ['SUPER_USUARIO', 'IMPRESORA_VER']
            },
            {
                label: 'Usuarios',
                icon: 'fa fa-users',
                items: [
                    {
                        label: 'Ver usuarios',
                        icon: 'fa fa-users',
                        routerLink: ['/usuarios'],
                        rol: ['SUPER_USUARIO', 'USUARIOS_VER']
                    },
                    {
                        label: 'Perfiles de usuario',
                        icon: 'fa fa-id-card-o',
                        routerLink: ['/perfiles'],
                        rol: ['SUPER_USUARIO', 'PERFILES_VER']
                    },
                    {
                        label: 'Roles',
                        icon: 'fa fa-key',
                        routerLink: ['/roles'],
                        rol: ['SUPER_USUARIO', 'USUARIOS_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'USUARIOS_VER', 'PERFILES_VER']
            },
            {
                label: 'Notificaciones',
                icon: 'fa fa-bell',
                routerLink: ['/notificaciones'],
                rol: ['SUPER_USUARIO', 'USUARIOS_VER']
            }
        ],
        rol: ['SUPER_USUARIO', 'UNIDADES_VER', 'BANCOS_VER', 'CUENTAS_BANCARIAS_VER',
            'PUNTO_VENTA_VER', 'HORARIOS_VER', 'SERIES_DOCUMENTOS_VER', 'PRODUCTOS_VER', 'CATEGORIAS_VER',
            'MARCAS_VER', 'CLIENTES_VER', 'PROVEEDORES_VER', 'USUARIOS_VER', 'PERFILES_VER', 'EMPLEADOS_VER', 'EMPLEADOS_ASISTENCIA_VER', 'CATALOGO_VER']
    },
    {
        label: 'Compras', icon: 'fa fa-archive',
        items: [
            {
                label: 'Ver compras',
                icon: 'fa fa-eye',
                routerLink: ['/compras'],
                rol: ['SUPER_USUARIO', 'COMPRAS_VER']
            },
            {
                label: 'Nueva compra',
                icon: 'fa fa-handshake-o',
                routerLink: ['/compras/nueva-compra'],
                rol: ['SUPER_USUARIO', 'COMPRAS_CREAR']
            },
            {
                label: 'Compras SUNAT',
                icon: 'fa fa-cloud-download',
                routerLink: ['/compras/sunat'],
                rol: ['SUPER_USUARIO', 'COMPRAS_VER']
            },
            {
                label: 'Ordenes de compra', icon: 'fa fa-file-text',
                items: [
                    {
                        label: 'Ver órdenes',
                        icon: 'fa fa-eye',
                        routerLink: ['/compras/ver-ordenes'],
                        rol: ['SUPER_USUARIO', 'ORDEN_COMPRA_VER']
                    },
                    {
                        label: 'Nueva orden',
                        icon: 'fa fa-file-text',
                        routerLink: ['/compras/nueva-orden'],
                        rol: ['SUPER_USUARIO', 'ORDEN_COMPRA_CREAR']
                    }
                ],
                rol: ['SUPER_USUARIO', 'ORDEN_COMPRA_VER', 'ORDEN_COMPRA_CREAR']
            },
        ],
        rol: ['SUPER_USUARIO', 'COMPRAS_VER', 'COMPRAS_CREAR', 'ORDEN_COMPRA_VER', 'ORDEN_COMPRA_CREAR']
    },
    {
        label: 'Ventas', icon: 'fa fa-shopping-cart',
        items: [
            {
                label: 'Ver comprobantes',
                icon: 'fa fa-eye',
                routerLink: ['/ventas/ver-comprobantes'],
                rol: ['SUPER_USUARIO', 'VENTAS_VER']
            },
            {
                label: 'Ver contingencias',
                icon: 'fa fa-eye',
                routerLink: ['/ventas/ver-contingencias'],
                rol: ['SUPER_USUARIO', 'VENTAS_VER']
            },
            {
                label: 'Nueva venta',
                icon: 'fa fa-shopping-basket',
                routerLink: ['/ventas/nueva-venta'],
                rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
            },
            {
                label: 'Nota de Crédito',
                icon: 'fa fa-file-text-o',
                routerLink: ['/ventas/emitir-nota-credito'],
                rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
            },
            {
                label: 'Nota de Débito',
                icon: 'fa fa-file-text-o',
                routerLink: ['/ventas/emitir-nota-debito'],
                rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
            },
            {
                label: 'Guías de remisión', icon: 'fa fa-file',
                items: [
                    {
                        label: 'Ver Guías',
                        icon: 'fa fa-eye',
                        routerLink: ['/guia-remision/ver-guias'],
                        rol: ['SUPER_USUARIO', 'GUIA_REMISION_CREAR']
                    },
                    {
                        label: 'Nueva Guía',
                        icon: 'fa fa-file-text-o',
                        routerLink: ['/guia-remision/emitir-guia'],
                        rol: ['SUPER_USUARIO', 'GUIA_REMISION_CREAR']
                    }
                ],
                rol: ['SUPER_USUARIO', 'GUIA_REMISION_CREAR']
            },
            {
                label: 'Cotizaciones', icon: 'fa fa-file-text',
                items: [
                    {
                        label: 'Ver Cotizaciones',
                        icon: 'fa fa-eye',
                        routerLink: ['/ventas/ver-cotizaciones'],
                        rol: ['SUPER_USUARIO', 'COTIZACION_VER']
                    },
                    {
                        label: 'Nueva Cotización',
                        icon: 'fa fa-file-text',
                        routerLink: ['/ventas/nueva-cotizacion'],
                        rol: ['SUPER_USUARIO', 'COTIZACION_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'COTIZACION_VER']
            },
            {
                label: 'Pedidos', icon: 'fa fa-file-text',
                items: [
                    {
                        label: 'Ver Pedidos',
                        icon: 'fa fa-eye',
                        routerLink: ['/ventas/ver-pedidos'],
                        rol: ['SUPER_USUARIO', 'COTIZACION_VER']
                    },
                    {
                        label: 'Nuevo Pedido',
                        icon: 'fa fa-file-text',
                        routerLink: ['/ventas/nuevo-pedido'],
                        rol: ['SUPER_USUARIO', 'COTIZACION_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'COTIZACION_VER']
            },
            {
                label: 'Despacho',
                icon: 'fa fa-external-link',
                routerLink: ['/ventas/despacho'],
                rol: ['SUPER_USUARIO', 'VENTAS_DESPACHO_VER']
            },
            {
                label: 'Descargas masivas',
                icon: 'fa fa-cloud-download',
                routerLink: ['/ventas/descargas-masivas'],
                rol: ['SUPER_USUARIO', 'VENTAS_VER']
            },
        ],
        rol: ['SUPER_USUARIO', 'COTIZACION_VER', 'GUIA_REMISION_CREAR', 'VENTAS_VER', 'VENTAS_CREAR']
    },

    {
        label: 'Tienda Online', icon: 'fa fa-globe',
        showCountNotifications: true,
        countNotificationTypes: ['PEDIDO_CATALOGO', 'PEDIDO_MENU'],
        items: [
            {
                label: 'Catálogo en línea',
                icon: 'fa fa-shopping-bag',
                routerLink: ['/gestion-catalogo'],
                rol: ['SUPER_USUARIO', 'CATALOGO_VER']
            },
            {
                label: 'Menú Cliente',
                icon: 'fa fa-cutlery',
                routerLink: ['/configuracion-menu-cliente'],
                rol: ['SUPER_USUARIO', 'MENU_CLIENTE_VER']
            },
            {
                label: 'Pedidos online',
                showCountNotifications: true,
                countNotificationTypes: ['PEDIDO_CATALOGO', 'PEDIDO_MENU'],
                icon: 'fa fa-list-alt',
                routerLink: ['/ventas/pedidos-tienda-online'],
                rol: ['SUPER_USUARIO', 'CATALOGO_VER', 'MENU_CLIENTE_VER']
            }
        ],
        rol: ['SUPER_USUARIO', 'CATALOGO_VER', 'MENU_CLIENTE_VER']
    },

    {
        label: 'Restaurante', icon: 'fa fa-cutlery',
        items: [
            {
                label: 'Comandero',
                icon: 'fa fa-clipboard',
                routerLink: ['/restaurante'],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_COMANDAS_VER']
            },
            {
                label: 'Pedidos',
                icon: 'fa fa-laptop',
                routerLink: ['/restaurante/pedidos'],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_PEDIDOS_VER']
            },
            {
                label: 'Cocina',
                icon: 'fa fa-hourglass-start',
                routerLink: ['/restaurante/cocina'],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_COCINA_VER']
            },
            {
                label: 'Por servir',
                icon: 'fa fa-bell',
                routerLink: ['/restaurante/por-servir'],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_COMANDAS_VER']
            },
            {
                label: 'Reparto',
                icon: 'fa fa-user-circle',
                routerLink: ['/restaurante/reparto'],
                rol: ['SUPER_USUARIO', 'REPARTO_VER']
            },
            {
                label: 'Carta QR',
                icon: 'pi pi-qrcode',
                routerLink: ['/restaurante/carta-qr'],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_MESAS_VER']
            },
            {
                label: 'Mantenimientos',
                icon: 'fa fa-wrench',
                items: [
                    {
                        label: 'Salones',
                        icon: 'fa fa-building-o',
                        routerLink: ['/restaurante/salones'],
                        rol: ['SUPER_USUARIO', 'RESTAURANTE_SALONES_VER']
                    },
                    {
                        label: 'Mesas',
                        icon: 'fa fa-tablet',
                        routerLink: ['/restaurante/mesas'],
                        rol: ['SUPER_USUARIO', 'RESTAURANTE_MESAS_VER']
                    },
                    {
                        label: 'Area de producción',
                        icon: 'fa fa-industry',
                        routerLink: ['/restaurante/zonas-produccion'],
                        rol: ['SUPER_USUARIO', 'RESTAURANTE_ZONAS_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_MESAS_VER', 'RESTAURANTE_SALONES_VER', 'RESTAURANTE_ZONAS_VER']
            },
            {
                label: 'Reporte propinas',
                icon: 'fa fa-book',
                routerLink: ['/restaurante/reporte-propinas'],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_PROPINAS_REPORTE']
            }
        ],
        rol: ['SUPER_USUARIO', 'RESTAURANTE_COMANDAS_VER', 'RESTAURANTE_MESAS_VER', 'RESTAURANTE_SALONES_VER', 'REPARTO_VER', 'RESTAURANTE_PROPINAS_REPORTE']
    },

    {
        label: 'Clínica', icon: 'pi pi-heart',
        items: [
            {
                label: 'Agenda',
                icon: 'pi pi-calendar',
                routerLink: ['/clinica/agenda'],
                rol: ['SUPER_USUARIO', 'CLINICA_CITAS_VER']
            },
            {
                label: 'Pacientes',
                icon: 'pi pi-users',
                routerLink: ['/clinica/pacientes'],
                rol: ['SUPER_USUARIO', 'CLINICA_PACIENTES_VER']
            },
            {
                label: 'Médicos',
                icon: 'pi pi-id-card',
                routerLink: ['/clinica/medicos'],
                rol: ['SUPER_USUARIO', 'CLINICA_MEDICOS_VER']
            },
            {
                label: 'Historia Clínica',
                icon: 'pi pi-file',
                routerLink: ['/clinica/historias-clinicas'],
                rol: ['SUPER_USUARIO', 'CLINICA_HISTORIA_VER']
            },
            {
                label: 'Planes de Tratamiento',
                icon: 'pi pi-chart-line',
                routerLink: ['/clinica/planes-tratamiento'],
                rol: ['SUPER_USUARIO', 'CLINICA_PLANES_VER']
            },
            {
                label: 'Reportes',
                icon: 'pi pi-chart-bar',
                routerLink: ['/clinica/reportes'],
                rol: ['SUPER_USUARIO', 'CLINICA_REPORTES_VER']
            }
        ],
        rol: ['SUPER_USUARIO', 'CLINICA_CITAS_VER', 'CLINICA_PACIENTES_VER', 'CLINICA_MEDICOS_VER', 'CLINICA_HISTORIA_VER', 'CLINICA_PLANES_VER', 'CLINICA_REPORTES_VER']
    },

    {
        label: 'Estacion de Servicios',
        icon: 'fa fa-tachometer',
        items: [
            {
                label: 'Gestionar islas',
                icon: 'fa fa-sitemap',
                routerLink: ['/contometro'],
                rol: ['SUPER_USUARIO', 'CONTOMETRO_VER'],
            },
            {
                label: 'Gestionar contómetros',
                icon: 'fa fa-cog',
                routerLink: ['/contometro/gestionar'],
                rol: ['SUPER_USUARIO', 'CONTOMETRO_VER'],
                requiresEsGasolinera: true
            },
            {
                label: 'Reporte de contometros',
                icon: 'fa fa-book',
                routerLink: ['/contometro/reporte'],
                rol: ['SUPER_USUARIO', 'CONTOMETRO_REPORTE'],
            }
        ],
        rol: ['SUPER_USUARIO', 'CONTOMETRO_VER', 'CONTOMETRO_REPORTE'],
    },
    {
        label: 'Operaciones',
        icon: 'fa fa-suitcase',
        items: [
            {
                label: 'Caja',
                icon: 'fa fa-money',
                routerLink: ['/caja'],
                rol: ['SUPER_USUARIO', 'CAJA_VER']
            },
            {
                label: 'Reporte de cajas',
                icon: 'fa fa-book',
                routerLink: ['/caja/reporte'],
                rol: ['SUPER_USUARIO', 'CAJA_VER_HISTORIAL']
            },
            {
                label: 'Membresias',
                icon: 'fa fa-meetup',
                routerLink: ['/membresias'],
                rol: ['SUPER_USUARIO', 'MEMBRESIAS_VER']
            },
            {
                label: 'Cuentas por cobrar',
                icon: 'fa fa-bookmark',
                routerLink: ['/cuentas-por-cobrar'],
                rol: ['SUPER_USUARIO', 'CUENTAS_POR_COBRAR_VER']
            },
            {
                label: 'Cuentas por Pagar',
                icon: 'fa fa-bookmark',
                routerLink: ['/cuentas-por-cobrar/pagar'],
                rol: ['SUPER_USUARIO', 'CUENTAS_POR_PAGAR_VER']
            },
            {
                label: 'Facturación Electrónica', icon: 'fa fa-file-pdf-o',
                items: [
                    {
                        label: 'Resumen diario',
                        icon: 'fa fa-file-o',
                        routerLink: ['/facturacion-electronica/resumen-diario/ver-resumenes-diarios'],
                        rol: ['SUPER_USUARIO', 'RESUMEN_DIARIO_VER']
                    },
                    {
                        label: 'Comunicación de baja',
                        icon: 'fa fa-file-text',
                        routerLink: ['/facturacion-electronica/comunicacion-baja/ver-comunicaciones-baja'],
                        rol: ['SUPER_USUARIO', 'COMUNICACION_BAJA_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'RESUMEN_DIARIO_VER', 'COMUNICACION_BAJA_VER']
            },
            {
                label: 'Inventario',
                icon: 'fa fa-database',
                rol: ['SUPER_USUARIO', 'INVENTARIO_VER', 'INVENTARIO_AJUSTAR', 'INVENTARIO_TRASLADAR', 'INVENTARIO_ORDENES_PRODUCCION'],
                items: [
                    {
                        label: 'Inventario de productos',
                        icon: 'fa fa-database',
                        routerLink: ['/inventario'],
                        rol: ['SUPER_USUARIO', 'INVENTARIO_VER']
                    },
                    {
                        label: 'Lotes y series',
                        icon: 'fa fa-file-text-o',
                        routerLink: ['/inventario/lotes'],
                        rol: ['SUPER_USUARIO', 'INVENTARIO_VER']
                    },
                    {
                        label: 'Ajustes de inventario',
                        icon: 'fa fa-cog',
                        routerLink: ['/inventario-ajustes'],
                        rol: ['SUPER_USUARIO', 'INVENTARIO_AJUSTAR']
                    },
                    {
                        label: 'Traslados de inventario',
                        icon: 'fa fa-exchange',
                        routerLink: ['/inventario-traslados'],
                        rol: ['SUPER_USUARIO', 'INVENTARIO_TRASLADAR']
                    },
                    {
                        label: 'Ordenes de producción',
                        icon: 'fa fa-money',
                        routerLink: ['/inventario-ordenes-produccion'],
                        rol: ['SUPER_USUARIO', 'INVENTARIO_ORDENES_PRODUCCION']
                    }
                ],
            },
        ],
        rol: ['SUPER_USUARIO', 'CAJA_VER', 'CAJA_VER_HISTORIAL', 'CUENTAS_POR_COBRAR_VER', 'RESUMEN_DIARIO_VER', 'COMUNICACION_BAJA_VER', 'INVENTARIO_VER', 'INVENTARIO_AJUSTAR', 'INVENTARIO_TRASLADAR', 'INVENTARIO_ORDENES_PRODUCCION']
    },
    {
        label: 'Reportes',
        icon: 'fa fa-file-text',
        items: [
            {
                label: 'Reporte de ventas',
                icon: 'fa fa-file-archive-o',
                routerLink: ['/reportes/reporte-ventas'],
                rol: ['SUPER_USUARIO', 'REPORTE_VENTAS']
            },
            {
                label: 'Reporte de movimientos',
                icon: 'fa fa-file-excel-o',
                routerLink: ['/reportes/reporte-movimientos'],
                rol: ['SUPER_USUARIO', 'REPORTE_MOVIMIENTOS']
            },
            {
                label: 'Reporte ABC',
                icon: 'fa fa-sort-amount-desc',
                routerLink: ['/reportes/reporte-abc'],
                rol: ['SUPER_USUARIO', 'REPORTE_ABC']
            },
            {
                label: 'Reporte de margenes',
                icon: 'fa fa-percent',
                routerLink: ['/reportes/reporte-margenes'],
                rol: ['SUPER_USUARIO', 'REPORTE_MARGENES']
            },
            {
                label: 'Reporte de rotacion de inventario',
                icon: 'fa fa-refresh',
                routerLink: ['/reportes/reporte-rotacion'],
                rol: ['SUPER_USUARIO', 'REPORTE_ROTACION']
            },
            {
                label: 'Comparativo de ventas',
                icon: 'fa fa-balance-scale',
                routerLink: ['/reportes/reporte-comparativo-ventas'],
                rol: ['SUPER_USUARIO', 'REPORTE_COMPARATIVO_VENTAS']
            },
            {
                label: 'Reporte de clientes',
                icon: 'fa fa-users',
                routerLink: ['/reportes/reporte-clientes'],
                rol: ['SUPER_USUARIO', 'REPORTE_CLIENTES']
            },
            {
                label: 'Reportes Restaurante', icon: 'fa fa-file-text',
                items: [
                    {
                        label: 'Rendimiento de mozos',
                        icon: 'fa fa-user-circle',
                        routerLink: ['/reportes/reporte-mozos-performance'],
                        rol: ['SUPER_USUARIO', 'REPORTE_MOZOS_PERFORMANCE']
                    },
                    {
                        label: 'Platos por horario',
                        icon: 'fa fa-clock-o',
                        routerLink: ['/reportes/reporte-platos-horario'],
                        rol: ['SUPER_USUARIO', 'REPORTE_PLATOS_HORARIO']
                    },
                    {
                        label: 'Comandas anuladas',
                        icon: 'fa fa-times-circle',
                        routerLink: ['/reportes/reporte-comandas-anuladas'],
                        rol: ['SUPER_USUARIO', 'REPORTE_COMANDAS_ANULADAS']
                    },
                    {
                        label: 'Analisis Food Cost',
                        icon: 'fa fa-pie-chart',
                        routerLink: ['/reportes/reporte-food-cost'],
                        rol: ['SUPER_USUARIO', 'REPORTE_FOOD_COST']
                    }
                ],
                rol: ['SUPER_USUARIO', 'COTIZACION_VER']
            },
        ],
        rol: ['SUPER_USUARIO', 'REPORTE_VENTAS']
    },
    {
        label: 'Fidelización',
        icon: 'fa fa-star',
        items: [
            {
                label: 'Configuración',
                icon: 'fa fa-cog',
                routerLink: ['/loyalti/config'],
                rol: ['SUPER_USUARIO', 'LOYALTI_CONFIG_VER']
            },
            {
                label: 'Clientes Fidelizados',
                icon: 'fa fa-users',
                routerLink: ['/loyalti/customers'],
                rol: ['SUPER_USUARIO', 'LOYALTI_CUSTOMERS_VER']
            },
            {
                label: 'Definición de Cupones',
                icon: 'fa fa-ticket',
                routerLink: ['/loyalti/coupon-defs'],
                rol: ['SUPER_USUARIO', 'LOYALTI_COUPON_DEFS_VER']
            },
            {
                label: 'Cupones Emitidos',
                icon: 'fa fa-tags',
                routerLink: ['/loyalti/coupons'],
                rol: ['SUPER_USUARIO', 'LOYALTI_COUPONS_VER']
            }
        ],
        rol: ['SUPER_USUARIO', 'LOYALTI_CONFIG_VER', 'LOYALTI_CUSTOMERS_VER', 'LOYALTI_COUPON_DEFS_VER', 'LOYALTI_COUPONS_VER']
    },
    {
        label: 'Herramientas Cont.',
        icon: 'fa fa-calculator',
        routerLink: ['/herramientas-contadores'],
        rol: ['SUPER_USUARIO', 'HERRAMIENTAS_CONTADORES']
    }
];

export const menuShortcuts = [
    // --- Ventas / operación diaria ---
    {
        label: 'Nueva venta',
        grupo: 'Ventas',
        value: {
            nombre: 'Nueva venta',
            icono: 'fa fa-cart-plus',
            ruta: '/ventas/nueva-venta',
            rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
        },
    },
    {
        label: 'Ver comprobantes',
        grupo: 'Ventas',
        value: {
            nombre: 'Ver comprobantes',
            icono: 'fa fa-shopping-basket',
            ruta: '/ventas/ver-comprobantes',
            rol: ['SUPER_USUARIO', 'VENTAS_VER']
        }
    },
    {
        label: 'Nota de crédito',
        grupo: 'Ventas',
        value: {
            nombre: 'Nota de crédito',
            icono: 'fa fa-undo',
            ruta: '/ventas/emitir-nota-credito',
            rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
        }
    },
    {
        label: 'Nueva Cotización',
        grupo: 'Ventas',
        value: {
            nombre: 'Nueva Cotización',
            icono: 'fa fa-file-text-o',
            ruta: '/ventas/nueva-cotizacion',
            rol: ['SUPER_USUARIO', 'COTIZACION_VER']
        },
    },
    {
        label: 'Nuevo pedido',
        grupo: 'Ventas',
        value: {
            nombre: 'Nuevo pedido',
            icono: 'fa fa-cart-arrow-down',
            ruta: '/ventas/nuevo-pedido',
            rol: ['SUPER_USUARIO', 'COTIZACION_VER']
        }
    },
    {
        label: 'Nueva guía de remisión',
        grupo: 'Ventas',
        value: {
            nombre: 'Nueva guía de remisión',
            icono: 'fa fa-truck',
            ruta: '/guia-remision/emitir-guia',
            rol: ['SUPER_USUARIO', 'GUIA_REMISION_CREAR']
        }
    },
    {
        label: 'Pedidos online',
        grupo: 'Ventas',
        value: {
            nombre: 'Pedidos online',
            icono: 'fa fa-globe',
            ruta: '/ventas/pedidos-tienda-online',
            rol: ['SUPER_USUARIO', 'CATALOGO_VER']
        }
    },
    // --- Operación / finanzas ---
    {
        label: 'Caja',
        grupo: 'Operación y finanzas',
        value: {
            nombre: 'Caja',
            icono: 'fa fa-money',
            ruta: '/caja',
            rol: ['SUPER_USUARIO', 'CAJA_VER']
        },
    },
    {
        label: 'Cuentas por cobrar',
        grupo: 'Operación y finanzas',
        value: {
            nombre: 'Cuentas por cobrar',
            icono: 'fa fa-bookmark',
            ruta: '/cuentas-por-cobrar',
            rol: ['SUPER_USUARIO', 'CUENTAS_POR_COBRAR_VER']
        }
    },
    {
        label: 'Dashboard',
        grupo: 'Operación y finanzas',
        value: {
            nombre: 'Dashboard',
            icono: 'fa fa-pie-chart',
            ruta: '/dashboard',
            rol: ['SUPER_USUARIO', 'DASHBOARD_VER']
        }
    },
    {
        label: 'Reporte de ventas',
        grupo: 'Operación y finanzas',
        value: {
            nombre: 'Reporte de ventas',
            icono: 'fa fa-line-chart',
            ruta: '/reportes/reporte-ventas',
            rol: ['SUPER_USUARIO', 'REPORTE_VENTAS']
        }
    },
    {
        label: 'Inventario',
        grupo: 'Operación y finanzas',
        value: {
            nombre: 'Inventario',
            icono: 'fa fa-database',
            ruta: '/inventario',
            rol: ['SUPER_USUARIO', 'INVENTARIO_VER']
        }
    },
    // --- Catálogo / administración ---
    {
        label: 'Articulos',
        grupo: 'Catálogo y administración',
        value: {
            nombre: 'Articulos',
            icono: 'fa fa-barcode',
            ruta: '/productos',
            rol: ['SUPER_USUARIO', 'PRODUCTOS_VER']
        }
    },
    {
        label: 'Clientes',
        grupo: 'Catálogo y administración',
        value: {
            nombre: 'Clientes',
            icono: 'fa fa-address-book',
            ruta: '/clientes',
            rol: ['SUPER_USUARIO', 'CLIENTES_VER']
        }
    },
    {
        label: 'Empleados',
        grupo: 'Catálogo y administración',
        value: {
            nombre: 'Empleados',
            icono: 'fa fa-users',
            ruta: '/empleados',
            rol: ['SUPER_USUARIO', 'EMPLEADOS_VER']
        },
    },
    {
        label: 'Usuarios',
        grupo: 'Catálogo y administración',
        value: {
            nombre: 'Usuarios',
            icono: 'fa fa-id-card-o',
            ruta: '/usuarios',
            rol: ['SUPER_USUARIO', 'USUARIOS_VER']
        }
    },
    // --- Compras ---
    {
        label: 'Ver compras',
        grupo: 'Compras',
        value: {
            nombre: 'Ver compras',
            icono: 'fa fa-archive',
            ruta: '/compras',
            rol: ['SUPER_USUARIO', 'COMPRAS_VER']
        }
    },
    {
        label: 'Nueva compra',
        grupo: 'Compras',
        value: {
            nombre: 'Nueva compra',
            icono: 'fa fa-handshake-o',
            ruta: '/compras/nueva-compra',
            rol: ['SUPER_USUARIO', 'COMPRAS_CREAR']
        }
    },
    {
        label: 'Compras SUNAT',
        grupo: 'Compras',
        value: {
            nombre: 'Compras SUNAT',
            icono: 'fa fa-cloud-download',
            ruta: '/compras/sunat',
            rol: ['SUPER_USUARIO', 'COMPRAS_VER']
        }
    },
    {
        label: 'Ver ordenes de compra',
        grupo: 'Compras',
        value: {
            nombre: 'Ver ordenes de compra',
            icono: 'fa fa-folder-open-o',
            ruta: '/compras/ver-ordenes',
            rol: ['SUPER_USUARIO', 'ORDEN_COMPRA_VER']
        }
    },
    {
        label: 'Nueva orden de compra',
        grupo: 'Compras',
        value: {
            nombre: 'Nueva orden de compra',
            icono: 'fa fa-file-text',
            ruta: '/compras/nueva-orden',
            rol: ['SUPER_USUARIO', 'ORDEN_COMPRA_CREAR']
        }
    },
    // --- Restaurante ---
    {
        label: 'Restaurante Comandero',
        grupo: 'Restaurante',
        value: {
            nombre: 'Restaurante Comandero',
            icono: 'fa fa-clipboard',
            ruta: '/restaurante/comandero',
            rol: ['SUPER_USUARIO', 'RESTAURANTE_COMANDAS_VER']
        }
    },
    {
        label: 'Carta QR',
        grupo: 'Restaurante',
        value: {
            nombre: 'Carta QR',
            icono: 'pi pi-qrcode',
            ruta: '/restaurante/carta-qr',
            rol: ['SUPER_USUARIO', 'RESTAURANTE_MESAS_VER']
        }
    },
    {
        label: 'Cocina',
        grupo: 'Restaurante',
        value: {
            nombre: 'Cocina',
            icono: 'fa fa-cutlery',
            ruta: '/restaurante/cocina',
            rol: ['SUPER_USUARIO', 'RESTAURANTE_COCINA_VER']
        }
    },
    {
        label: 'Por servir',
        grupo: 'Restaurante',
        value: {
            nombre: 'Por servir',
            icono: 'fa fa-bell',
            ruta: '/restaurante/por-servir',
            rol: ['SUPER_USUARIO', 'RESTAURANTE_COMANDAS_VER']
        }
    },
    {
        label: 'Pedidos restaurante',
        grupo: 'Restaurante',
        value: {
            nombre: 'Pedidos restaurante',
            icono: 'fa fa-laptop',
            ruta: '/restaurante/pedidos',
            rol: ['SUPER_USUARIO', 'RESTAURANTE_PEDIDOS_VER']
        }
    },
    {
        label: 'Reparto',
        grupo: 'Restaurante',
        value: {
            nombre: 'Reparto',
            icono: 'fa fa-motorcycle',
            ruta: '/restaurante/reparto',
            rol: ['SUPER_USUARIO', 'REPARTO_VER']
        }
    },
    // --- Clínica ---
    {
        label: 'Agenda clínica',
        grupo: 'Clínica',
        value: {
            nombre: 'Agenda clínica',
            icono: 'fa fa-calendar',
            ruta: '/clinica/agenda',
            rol: ['SUPER_USUARIO', 'CLINICA_CITAS_VER']
        }
    }
];
